import { ClearOutlined } from '@ant-design/icons'
import { Button, Form, Select, Space } from 'antd'
import type { FormInstance } from 'antd/es/form'
import { FC } from 'react'
import Contractor from '../../../../components/form-items/contractor/contractor'
import { orderStatusOptions } from '../../constants/status-labels'

interface FilterFormProps {
    form: FormInstance
    onSearch: () => void
    onClear: () => void
}

const FilterForm: FC<FilterFormProps> = ({ form, onSearch, onClear }) => {
    return (
        <Form form={form} component={false} onFieldsChange={onSearch}>
            <Space wrap>
                <Form.Item name='orderStatus' noStyle>
                    <Select
                        allowClear
                        placeholder='Статус'
                        options={orderStatusOptions}
                        style={{ width: 200 }}
                    />
                </Form.Item>
                <div style={{ width: 220 }}>
                    <Contractor name='client' noStyle rules={[]} />
                </div>
                <Button icon={<ClearOutlined />} title='Сбросить фильтры' onClick={onClear}>
                    Сброс
                </Button>
            </Space>
        </Form>
    )
}

export default FilterForm
